import jQuery from 'jquery';
import moment from 'moment-timezone';
window.bwjQuery = jQuery.noConflict( true );
window.moment = moment;

if ( !window.jQuery ) {
	window.jQuery = window.bwjQuery;
	window.$ = window.bwjQuery;
}

// some of these are old and need require instead of import
require('bootstrap-sass');
require('jquery-lazy/jquery.lazy.min');
require('jquery-lazy/jquery.lazy.plugins.min');
require('@zeitiger/elevatezoom');
require('formvalidation/dist/js/formValidation.min');
require('formvalidation/dist/js/framework/bootstrap.min');
import 'bootstrap-datepicker';
import 'bootstrap-datetime-picker';
import 'slick-carousel';
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';
import 'jquery-mask-plugin';
window.intlTelInput = intlTelInput;